// @flow

import NestedResource from 'speed-js-core/src/api/NestedResource';

export default class CaseCurrentSignalsResource extends NestedResource {
    basePath: string = 'cases/cases/{parent}/signals/';

    objectPath: string = 'cases/cases/{parent}/signals/{ident}/';
}
